var render = function render(){var _vm=this,_c=_vm._self._c;return _c('multiselect',{staticClass:"login-selector",attrs:{"options":_vm.options,"multiple":false,"close-on-select":false,"clear-on-select":false,"preserve-search":true,"placeholder":"Choisissez un client"},on:{"input":_vm.emitLogin},model:{value:(_vm.login),callback:function ($$v) {_vm.login=$$v},expression:"login"}})
}
var staticRenderFns = []

export { render, staticRenderFns }